<!--
 * @Author: HWD
 * @Date: 2021-11-04 10:22:59
 * @LastEditors: HWD
 * @LastEditTime: 2021-11-22 09:31:36
 * Copyright 2021 © HWD, All Rights Reserved. 
 * @Description: 
-->
<template>
  <div class="reg">
    <!-- <swiper :source="window.source" /> -->
    <div class="userinfo">
      <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm">
        <el-form-item label="" prop="name">
          <el-input
            type="text"
            v-model="ruleForm.name"
            autocomplete="off"
            placeholder="请输入你的姓名"     
            prefix-icon="el-icon-user"
          ></el-input>
        </el-form-item>
        <el-form-item label="" prop="phoneNumber">
          <el-input
            type="text"
            v-model="ruleForm.phoneNumber"
            autocomplete="off"
            placeholder="请输入你的联系手机"
            prefix-icon="el-icon-phone-outline"
          ></el-input>
        </el-form-item>

        <el-form-item label="" prop="province">
            <el-cascader class="el-input" placeholder="请选择省/市(县)" :options="options" ref="cascaderAddr" @change="handleChange" clearable></el-cascader>
        </el-form-item>
        <el-form-item label="" prop="carNumber">
          <el-input
            type="text"
            v-model="carNumberUpperCase"
            autocomplete="off"
            placeholder="请输入你的车牌号"
            prefix-icon="el-icon-c-scale-to-original"
          >
          </el-input>
        </el-form-item>
      </el-form> 
    </div>
    <div class="btn">
        <div class="ok" @click="ok">确认</div>
        <div class="reset" @click="reset">重置</div>
    </div> 

  </div>
</template>

<script>
//let pcas = require('../assets/pc_json')
//import Swiper from '@/components/Swiper'
import Fetch from '../utils/fetch';
//import QrCode from "@/components/QrCode"
// import SpreadRegister from "@/components/SpreadRegister"
//import Fetch from "./utils/fetch";
export default {
  name: "App",
  components: {
    //Swiper
    //QrCode,
    // SpreadRegister
  },
  data() {
    var checkPhoneNumber = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("联系手机不能为空"));
      }
      setTimeout(() => {
        console.log(value);
        console.log(typeof value);
        var re = /^[0-9]+.?[0-9]*/; //判断字符串是否为数字//判断正整数/[1−9]+[0−9]∗]∗/
        if (!re.test(value)) {
          callback(new Error("请输入数字值"));
        }else{
            console.log(value.toString().length)
          if (value.toString().length < 11) {
            callback(new Error("手机号码应是11位，你输的位数是" + value.toString().length + "位"));
          } else if (value.toString().length > 11){
              callback(new Error("手机号码应是11位，你输的位数是" + value.toString().length + "位"));
          }
          else {
              var myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
                if (!myreg.test(value)) {
                    callback(new Error("请输入的手机号不合规"));
                //return false;
                } else {
                    callback();
                //return true;
                }
          } 
        }

      }, 1000);
    };
    return {
      window: {
        interval: 5000,
        showState: true,
        adpic: [

        ],
        source: "",
      },
      ruleForm: {
        name: "AAA",
        phoneNumber: "13088888888",
        carNumber: "皖A 55555",
        province: '皖A',
        SpreadUserId:'1'
      },
      rules: {
        name: [
          { required: true, message: "请输入你的姓名", trigger: "blur" },
          { min: 2, max: 5, message: "长度在 2 到 5 个字符", trigger: "blur" },
        ],
        phoneNumber: [
          { required: true, message: "请输入你的联系手机", trigger: "blur" },
          { validator: checkPhoneNumber, trigger: "blur" },

        ],
        carNumber: [
          { required: true, message: "请输入你的车牌号", trigger: "blur" },
          { min: 8, max: 9, message: "车牌号码应是5-6位", trigger: "blur" },
        ],
      },
      //options:pcas,
      options: [
          {
            value: '皖',
            label: '安徽省',
            children: [
                {
                    value: 'A',
                    label: '合肥市',
                }, 
                {
                    value: 'B',
                    label: '芜湖市',
                }
            ]
          }
        ]
    };
  },
  created() {
    this.getUrlObj();
    this.getData();
    this.ruleForm.SpreadUserId=this.$route.params.SpreadUserId
    console.log(this.ruleForm.SpreadUserId)
  },
  mounted() {},
  updated() {},
  //computed () {},
  computed : {
    carNumberUpperCase : {
              get: function(){
                  return this.ruleForm.carNumber;
              },
              set : function(val){
                //console.log(val)
                //let value =[]
                //value = this.ruleForm.province + '·'+ val.toUpperCase();
                
                  //console.log(l)
                  let temp = val.split(' ')
                  let l = temp.length
                  //console.log(temp)
                  //console.log(temp[l-1])
                  temp = temp[l-1].toUpperCase()
                  this.ruleForm.carNumber = this.ruleForm.province + ' '+ temp
                  //this.ruleForm.carNumber = this.ruleForm.province + '·'+ val.toUpperCase();

              }
    }
  },
  methods: {
    getUrlObj() {
      //   var ret = {};
      //   console.log(location.search, location);
      //   var search = location.search.slice(1);
      //   console.log(search);
      //   search.replace(/([^?&]+)=([^?&]+)/g, function (s, v, k) {
      //     ret[v] = decodeURIComponent(k);
      //     //return k + "=" + v;
      //   });
      //   console.log(ret);
      //   return ret;
    },
    async getData() {
      // console.log(this.window.source)
      // const data = await Fetch("getAdInfo.php", {  });// { CarId: this.window.source }
      // console.log(data);
      // if (data.code == 200) {
      //   this.window.showState = data.data.showAd
      //   this.window.adpic = data.data.adpic;
      // }
    },
    handleChange(e, form, thsAreaCode) {
        thsAreaCode = this.$refs['cascaderAddr'].getCheckedNodes()[0].path// 注意2： 获取label值
        //thsAreaCode = this.$refs['cascaderAddr'].getCheckedNodes()[0].pathLabels// 注意2： 获取label值
        //console.log(thsAreaCode) // 注意3： 最终结果是个一维数组对象
        //console.log(thsAreaCode[0] + thsAreaCode[1])
        //console.log(thsAreaCode[0] + thsAreaCode[1] + thsAreaCode[2])
        this.ruleForm.province = thsAreaCode[0] + thsAreaCode[1]
    },
    async ok(){
        console.log(this.ruleForm)
        const data = await Fetch("register.php",this.ruleForm,'POST')
        console.log(data)
        if(data.code == 200){
          this.$message.success("1234")
          this.$router.go(-1)
        }
        // var client = new XMLHttpRequest();
        // client.open("GET", "http://localhost/movecarapi/register.php")
        // client.setRequestHeader('Content-Type','text/html')
        // client.onreadystatechange = function() { /* do something */ }
        // client.send()

    //     $.ajax({
    //     type: "POST",
    //     url: "http://localhost/movecarapi/register.php",
    //     xhrFields: {withCredentials: true},
    //     crossDomain: true,
    //     data: "",
    //     beforeSend: function (XMLHttpRequest) {
    //         XMLHttpRequest.setRequestHeader("test-token", 'abcd');
    //         XMLHttpRequest.setRequestHeader("test-sessid", 'abcd');
    //     },
    //     error: function (XMLHttpRequest) {
    //         if (XMLHttpRequest.status === 401) {

    //         }
    //     },
    //     success: function () {},
    //     complete: function () {}
    // });


    // fetch("http://localhost/movecarapi/register.php", {
    // method: "POST",
    // headers: {
    //     'Content-Type': 'application/json'
    // },
    // body: JSON.stringify(this.ruleForm)
    // }).then(function(response) {
    //     // do sth
    //     console.log(response)
    // })


        // fetch("http://localhost/movecarapi/register.php",{
        //     method:'POST',
        //     headers:{
        //         //'Accept':'application/json',
        //         'Content-Type':'application/json',
        //         'Access-Control-Allow-Origin':'*',
        //         'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type',
        //         //'Access-Control-Allow-Methods': 'PUT,POST,GET,DELETE,OPTIONS',
        //         'Access-Control-Allow-Methods': 'POST'
        //     },
        //     body:JSON.stringify(this.ruleForm)
        // }).then(response=>response.json())
        // .then(result=>{console.log(result)})
        // fetch("http://localhost/movecarapi/register.php", {
        //     method: "POST",
        //     mode: "cors",
        //     headers: {
        //         'Content-Type': 'application/x-www-form-urlencoded'
        //     },
        //     body: "q=参数q"
        // }).then(function(response) {
        //     // do sth
        //     console.log(response)
        // });
    },
    reset(){
      //this.$refs.cascaderAddr.inputValue = ''
      this.ruleForm = this.$options.data().ruleForm
      this.$refs.cascaderAddr.handleClear()
      // console.log(this.$refs.cascaderAddr.handleClear())
      //this.$refs.cascaderAddr.resetFields()
      //console.log(this.$refs.cascaderAddr.inputValue = '')
      // this.options = {}
      //   this.options.stopPropagation = () => {}
      //   try{
      //       this.$refs.cascader.clearValue(this.options)
      //   }catch(err){
      //       this.$refs.cascader.handleClear(this.options)
      //   }
      console.log(this.ruleForm)
      
    }
  },
};
</script>

<style scoped>
.userinfo {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.el-form {
  width: 13.7rem;
}
.el-form-item {
  margin-bottom: 0 !important;
}
.el-input {
  margin-top: 1.8rem;
  /* width:80%; */
}
.el-select .el-input {
width: 130px;
}
.input-with-select .el-input-group__prepend {
background-color: #fff;
}
.btn{
    /* margin-top:2rem;
    width: 13.7rem;
    
    display: flex; */
    position:absolute;
    width:100vw;
    height:2rem;
    line-height: 2rem;
    background: #eee;
    bottom:0;
    left: 0;
    display: flex;
    color: lightslategrey;
}
.btn div{
    flex:1;
    background-color: #409EFF;
    color:#fff;
}
.btn div:hover{
  background-color: #0c5094;
}
.btn .ok{
    border-right: 1px solid #eee;
    
    /* border-color: #409EFF; */
}
</style>
